/**
 * How much shadow sits under text and icons in the header, player and edge
 * buttons — each signed-in person's own choice (Gordon 2026-11-02: "as default
 * a little less, users can add as much or as little as they want").
 * globals.css multiplies the per-mode strength (0.12 light, 0.6 dark) by
 * --bb-shadow-user; no choice = 1 (BB's default).
 */

export const TEXT_SHADOW_LEVELS = ['0', '0.5', '1', '2', '3'] as const;
export type TextShadowLevel = (typeof TEXT_SHADOW_LEVELS)[number];

/** Device copy of the person's choice, replayed before first paint (layout.tsx). */
export const LS_TEXT_SHADOW = 'bb-text-shadow';

export function cleanTextShadow(v: unknown): TextShadowLevel | null {
  return typeof v === 'string' && (TEXT_SHADOW_LEVELS as readonly string[]).includes(v) ? (v as TextShadowLevel) : null;
}

/** null = BB's default (the variable is removed). */
export function applyTextShadow(level: string | null | undefined): void {
  if (typeof document === 'undefined') return;
  const l = cleanTextShadow(level);
  const root = document.documentElement;
  if (l && l !== '1') root.style.setProperty('--bb-shadow-user', l);
  else root.style.removeProperty('--bb-shadow-user');
  try {
    if (l && l !== '1') localStorage.setItem(LS_TEXT_SHADOW, l);
    else localStorage.removeItem(LS_TEXT_SHADOW);
  } catch { /* private mode */ }
}
